(function () {
  'use strict';
  var KEY = 'lipsglow_cookie_choice_2026_v1';
  var SIX_MONTHS = 183 * 24 * 60 * 60 * 1000;
  function init() {
    var root = document.getElementById('LipsGlowCookieConsent');
    if (!root) return;
    var banner = root.querySelector('[data-lgc-banner]');
    var overlay = root.querySelector('[data-lgc-overlay]');
    var dialog = root.querySelector('[data-lgc-modal]');
    var bannerError = root.querySelector('[data-lgc-banner-error]');
    var modalError = root.querySelector('[data-lgc-modal-error]');
    var links = Array.prototype.slice.call(document.querySelectorAll('[data-lgc-open]'));
    var buttons = Array.prototype.slice.call(root.querySelectorAll('button'));
    var switches = {
      preferences: root.querySelector('[data-lgc-toggle="preferences"]'),
      analytics: root.querySelector('[data-lgc-toggle="analytics"]'),
      marketing: root.querySelector('[data-lgc-toggle="marketing"]')
    };
    var api = null, lastFocus = null, busy = false, nativeShowing = false;
    var modalWasFromBanner = false;
    function safeStoredDate() {
      try {
        var parsed = JSON.parse(localStorage.getItem(KEY) || 'null');
        return parsed && typeof parsed.at === 'number' ? parsed.at : 0;
      } catch (e) { return 0; }
    }
    function saveDate() {
      try { localStorage.setItem(KEY, JSON.stringify({at: Date.now()})); } catch (e) {}
    }
    function consent() {
      try { return api && api.currentVisitorConsent() || null; }
      catch(e) { return null; }
    }
    function currentSelections() {
      var c = consent() || {};
      return {
        preferences: c.preferences === 'yes',
        analytics: c.analytics === 'yes',
        marketing: c.marketing === 'yes'
      };
    }
    function allAnswered() {
      var c = consent();
      return !!c && ['preferences','analytics','marketing'].every(function(key) {
        return c[key] === 'yes' || c[key] === 'no';
      });
    }
    function nativeBannerPresent() {
      var selectors = [
        '#shopify-pc__banner',
        '.shopify-pc__banner__dialog',
        '#shopify-pc__banner__dialog',
        'shopify-privacy-banner',
        '[data-shopify-privacy-banner]'
      ];
      for (var i=0; i<selectors.length; i++) {
        var node = document.querySelector(selectors[i]);
        if (node && node !== root && !root.contains(node) &&
            !node.hidden && node.getAttribute('aria-hidden') !== 'true') {
          try {
            var css = window.getComputedStyle(node);
            if (css.display !== 'none' && css.visibility !== 'hidden') return true;
          } catch(e) {return true;}
        }
      }
      return false;
    }
    function switchState(obj) {
      Object.keys(switches).forEach(function(k) {
        if(switches[k])switches[k].checked=!!obj[k];
      });
    }
    function errorMessage(message) {
      bannerError.textContent = message;
      modalError.textContent = message;
      bannerError.hidden = banner.hidden || false;
      modalError.hidden = overlay.hidden || false;
    }
    function clearErrors() {
      bannerError.hidden = true;
      modalError.hidden = true;
    }
    function setBusy(value) {
      busy = !!value;
      buttons.forEach(function(button) {
        if(button.hasAttribute('data-lgc-close')) return;
        button.disabled=busy;
      });
    }
    function closeModal() {
      overlay.hidden = true;
      banner.removeAttribute('inert');
      var page=document.querySelector('.page-wrapper');if(page)page.removeAttribute('inert');
      document.body.classList.remove('lgc-modal-open');
      clearErrors();
      if(lastFocus && typeof lastFocus.focus==='function')lastFocus.focus();
    }
    function closeAll() {
      banner.hidden = true;
      overlay.hidden = true;
      root.hidden = true;
      banner.removeAttribute('inert');
      var page=document.querySelector('.page-wrapper');if(page)page.removeAttribute('inert');
      document.body.classList.remove('lgc-modal-open');
      clearErrors();
    }
    function showBanner() {
      if(nativeShowing || nativeBannerPresent()){ nativeShowing=true; closeAll(); return; }
      root.hidden=false;
      banner.hidden=false;
    }
    function openModal() {
      if(!api) return;
      if (nativeShowing && window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        window.privacyBanner.showPreferences();
        return;
      }
      clearErrors();
      lastFocus = document.activeElement;
      modalWasFromBanner = !banner.hidden;
      switchState(currentSelections());
      root.hidden = false;
      overlay.hidden = false;
      banner.setAttribute('inert','');
      var page=document.querySelector('.page-wrapper');if(page)page.setAttribute('inert','');
      document.body.classList.add('lgc-modal-open');
      dialog.focus();
    }
    function maybeDisplay() {
      if(!api)return;
      if(nativeBannerPresent()){nativeShowing=true;closeAll();return;}
      nativeShowing=false;
      var last = safeStoredDate();
      var hasExpired = !!last && Date.now()-last > SIX_MONTHS;
      if (!allAnswered() || hasExpired) showBanner();
      else closeAll();
    }
    function save(decision) {
      if(!api || busy)return;
      clearErrors();
      setBusy(true);
      try {
        api.setTrackingConsent({
          preferences: !!decision.preferences,
          analytics: !!decision.analytics,
          marketing: !!decision.marketing
        }, function(err) {
          setBusy(false);
          if(err) {
            errorMessage('Votre choix n’a pas pu être enregistré. Veuillez réessayer.');
            return;
          }
          var c=consent();
          var matched = c && ['preferences','analytics','marketing'].every(function(k) {
            return c[k] === (decision[k] ? 'yes' : 'no');
          });
          if(!matched) {
            errorMessage('Impossible de confirmer l’enregistrement de ce choix. Veuillez réessayer.');
            return;
          }
          saveDate();
          closeAll();
        });
      } catch(e) {
        setBusy(false);
        errorMessage('Le service de consentement est momentanément indisponible. Réessayez.');
      }
    }
    root.querySelectorAll('[data-lgc-reject]').forEach(function(b) {
      b.addEventListener('click',function(){save({preferences:false,analytics:false,marketing:false});});
    });
    root.querySelectorAll('[data-lgc-accept]').forEach(function(b) {
      b.addEventListener('click',function(){save({preferences:true,analytics:true,marketing:true});});
    });
    root.querySelector('[data-lgc-customize]').addEventListener('click',openModal);
    root.querySelector('[data-lgc-save]').addEventListener('click',function(){
      save({
        preferences:switches.preferences.checked,
        analytics:switches.analytics.checked,
        marketing:switches.marketing.checked
      });
    });
    root.querySelector('[data-lgc-close]').addEventListener('click',closeModal);
    overlay.addEventListener('click',function(e){if(e.target===overlay)closeModal();});
    document.addEventListener('keydown',function(e) {
      if(overlay.hidden)return;
      if(e.key==='Escape'){closeModal();return;}
      if(e.key!=='Tab')return;
      var focusable=Array.prototype.slice.call(dialog.querySelectorAll('button:not(:disabled),a[href],input:not(:disabled)'));
      if(!focusable.length)return;
      var first=focusable[0],last=focusable[focusable.length-1];
      if(e.shiftKey && (document.activeElement===first || document.activeElement===dialog)){e.preventDefault();last.focus();}
      if(!e.shiftKey && (document.activeElement===last || document.activeElement===dialog)){e.preventDefault();first.focus();}
    });
    links.forEach(function(link) {
      link.addEventListener('click',function(e) {
        if(nativeShowing && window.privacyBanner && typeof window.privacyBanner.showPreferences==='function') {
          e.preventDefault();
          window.privacyBanner.showPreferences();
          return;
        }
        if(api){e.preventDefault();openModal();}
      });
    });
    document.addEventListener('visitorConsentCollected',function() {
      if(!api)return;
      if(allAnswered() && !overlay.hidden) {
        // Keep the explicitly opened modal available until visitor closes it.
        return;
      }
      maybeDisplay();
    });
    // If the first-party Shopify banner is inserted asynchronously, don't present a duplicate.
    if(typeof MutationObserver!=='undefined'){
      var obs=new MutationObserver(function(){
        var present=nativeBannerPresent();
        if(present && !nativeShowing){nativeShowing=true;closeAll();}
        else if(!present && nativeShowing){nativeShowing=false;maybeDisplay();}
      });
      obs.observe(document.documentElement,{subtree:true,childList:true});
    }
    function ready(err) {
      if(err || !window.Shopify || !window.Shopify.customerPrivacy) {
        // Do not display a simulated consent interface if Shopify cannot store consent.
        closeAll();
        return;
      }
      api=window.Shopify.customerPrivacy;
      maybeDisplay();
    }
    if(window.Shopify && window.Shopify.customerPrivacy) ready(null);
    else if(window.Shopify && typeof window.Shopify.loadFeatures==='function')
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],ready);
    else closeAll();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
})();